// generated file, if you want to edit this file manually change the word "generated" to "manual"
import React from "react";
import clsx from "clsx";
import { makeThemedStyles } from "./../utils";
const useStylesForAppBarImage = makeThemedStyles(
  "QPRAppBar.AppBarImage",
  (theme) => ({
    AppBarImage: {},
  })
);
type ElementProps = React.ComponentProps<
  React.HTMLFactory<HTMLElementTagNameMap["div"]>
>;
export const AppBarImage: React.FunctionComponent<ElementProps> = (
  props: ElementProps
) => {
  const styles = useStylesForAppBarImage();
  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.AppBarImage)}
    />
  );
};
export default AppBarImage;
